import { render, staticRenderFns } from "./WeeklyScorecardReport.vue?vue&type=template&id=389a1e1f&scoped=true&"
import script from "./WeeklyScorecardReport.vue?vue&type=script&lang=js&"
export * from "./WeeklyScorecardReport.vue?vue&type=script&lang=js&"
import style0 from "./WeeklyScorecardReport.vue?vue&type=style&index=0&id=389a1e1f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389a1e1f",
  null
  
)

export default component.exports